import React from "react";
import { FacilityInspectionChangeRecord } from "../../../amorg-common";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { Table } from "../../../designSystem/Table";
import { P } from "../../../designSystem/typography/Body";
import { toDateTimeString } from "../../../utils/date";
import { Icon } from '../../../designSystem/icons/Icons';
import { getInspectionPointStatusIconDetails } from "../../../utils/facilityHelper";

type InspectionHistoryPanelProps = {
    history:FacilityInspectionChangeRecord[]
}
export function InspectionHistoryPanel(props:InspectionHistoryPanelProps):JSX.Element
{
    const pending = getInspectionPointStatusIconDetails('pending');
    const passed = getInspectionPointStatusIconDetails('passed');
    const failed = getInspectionPointStatusIconDetails('failed');

    return (
        <div>
            {props.history?.length === 0 && 
                <tr>
                    <td colSpan={4}>
                        Ingen ændringer er foretaget
                    </td>
                </tr>
            }
            {props.history?.length > 0 && 
                <Table style={{fontSize:'14px'}}>
                    {props.history.map((record, index) =>
                        <tr key={index}>
                            <td>
                                {record.type === 'update' &&
                                    <>
                                    {record.status === 'pending' &&
                                        <Icon name={pending.icon} color={pending.color} />
                                    }
                                    {record.status === 'passed' &&
                                        <Icon name={passed.icon} color={passed.color} />
                                    }
                                    {record.status === 'failed' &&
                                        <Icon name={failed.icon} color={failed.color} />
                                    }
                                    </>
                                }
                                {record.type === 'fileAdded' &&
                                    <Icon name="cloud_upload" />
                                }
                                {record.type === 'fileDeleted' &&
                                    <Icon name="interface_actions_delete" />
                                }
                            </td>

                            <td>
                                {record.type === 'update' &&
                                    <>Opdatering</>
                                }
                                {record.type === 'fileAdded' &&
                                    <>Billede tilføjet</>
                                }
                                {record.type === 'fileDeleted' &&
                                    <>Billede fjernet</>
                                }
                            </td>

                            <td>
                                {record.type === 'update' &&
                                    <Flex flexDirection='column' gap={4}>
                                        
                                        {record.status === 'pending' ? 'Ikke kontrolleret' 
                                            : record.status === 'passed' ? 'Godkendt' 
                                            : 'Ikke-godkendt'
                                        }
                                        
                                        <P><i>{record.comment}</i></P>
                                    </Flex>
                                }
                                {record.type === 'fileAdded' &&
                                    <div>
                                        <P>{record.publicFileName}</P>
                                    </div>
                                }
                                {record.type === 'fileDeleted' &&
                                    <div>
                                        <P>{record.publicFileName}</P>
                                    </div>
                                }
                            </td>
                            <td>{toDateTimeString(record.date)}</td>
                            <td>{record.user.name}</td>
                        </tr>
                    )}  
                </Table>
            }
        </div>
    );
}